
import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import { Getter } from "vuex-class";
import MobileEventSharingStatus from '@/types/sv-data/MobileEventSharingStatus';
import { markerIconClassOrDefault } from "@/assets/assetMarkerIcons";


@Component({
	components: {}
})
export default class EventSharingAsset extends Vue {
	@Prop()
	private assetShare: MobileEventSharingStatus

	@Prop()
	private iconStyle: string

	@Prop({default: false, type: Boolean})
	private nested: string

	@Getter("getFeature") private getFeature: (featureName: string[]) => boolean;

	private get assetIconClass(): string {
		const fallback = this.assetShare.userID ? "fas fa-walking" : "fas fa-star";
		return markerIconClassOrDefault(
			this.assetShare.customIcon,
			fallback,
			this.getFeature(["Assets", "CustomMarkerIcon"])
		);
	}

	private stateText(state: number): string {
		switch(state){
			case 1: //Maps to sent back we will use pending
				return "Pending";
			case 2:
				return "Accepted";
			case 3:
				return "Rejected";
			case 4:
				return "Left";
			case 5:
				return "Removed"
			case 6:
				return "Event Ended";
		}
	}

	@Emit("removeEventShare")
	private removeEventShare(){
		return this.assetShare;
	}

	private get stateClass(): string {
		let stateClass = this.nested ? "smallText " : "";
		if(this.assetShare.state != 1 && this.assetShare.state != 2){
			stateClass += "disabled text-muted"
		}
		return stateClass;
	}

	private get circleStateClass() {
		let stateClass = this.nested ? "smallCirlce " :"circle ";
		if(this.assetShare.state != 1 && this.assetShare.state != 2){
			stateClass += "disabled text-muted"
		}
		return stateClass;
	}
}
